import { Controller } from "@hotwired/stimulus"

// Debounced live search for organization workflow list on the organization show page.
// Submits to the organization show URL so query params stay on /organizations/:id.
export default class extends Controller {
  static targets = ["form", "activePanel", "inactivePanel", "tabField"]
  static values = {
    organizationUrl: String,
    activeSrc: String,
    inactiveSrc: String,
    debounceMs: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
    this.currentTab = paramsWorkflowTab() || "active"
    this.showPanel(this.currentTab)
    if (this.hasTabFieldTarget) {
      this.tabFieldTarget.value = this.currentTab
    }
    this.updateTabButtons(
      this.element.querySelector(`[data-workflow-search-tab-param="${this.currentTab}"]`)
    )
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.submitForm()
    }, this.debounceMsValue)
  }

  selectTab(event) {
    const tab = event.currentTarget.dataset.workflowSearchTabParam
    if (!tab || tab === this.currentTab) return

    this.currentTab = tab
    this.showPanel(tab)
    this.updateTabButtons(event.currentTarget)
    if (this.hasTabFieldTarget) {
      this.tabFieldTarget.value = this.currentTab
    }
    this.syncUrl()
  }

  syncUrl() {
    if (!this.hasFormTarget) return

    const url = new URL(this.organizationUrlValue, window.location.origin)
    const formData = new FormData(this.formTarget)
    formData.set("workflow_tab", this.currentTab)

    for (const [key, value] of formData.entries()) {
      if (value) url.searchParams.set(key, value)
      else url.searchParams.delete(key)
    }

    history.replaceState({}, "", url)
  }

  showPanel(tab) {
    if (this.hasActivePanelTarget) {
      this.activePanelTarget.classList.toggle("hidden", tab !== "active")
    }
    if (this.hasInactivePanelTarget) {
      this.inactivePanelTarget.classList.toggle("hidden", tab !== "inactive")
    }
  }

  updateTabButtons(activeButton) {
    this.element.querySelectorAll("[data-workflow-search-tab-param]").forEach((btn) => {
      const isActive = btn === activeButton
      btn.classList.toggle("active", isActive)
      if (isActive) {
        btn.setAttribute("aria-current", "page")
      } else {
        btn.removeAttribute("aria-current")
      }
    })
  }

  submitForm() {
    if (!this.hasFormTarget) return

    const frame = this.currentTab === "active" ? "active_workflows" : "inactive_workflows"
    this.formTarget.action = this.organizationUrlValue
    if (document.getElementById(frame)) {
      this.formTarget.dataset.turboFrame = frame
    } else {
      delete this.formTarget.dataset.turboFrame
    }
    if (this.hasTabFieldTarget) {
      this.tabFieldTarget.value = this.currentTab
    }
    this.formTarget.requestSubmit()
  }
}

function paramsWorkflowTab() {
  return new URLSearchParams(window.location.search).get("workflow_tab")
}
